const listCryptoDecimals: Record<string, number> = {
    'BAT': 4,
    'ADA': 6,
    'XRP': 6,
    'XLM': 7,
    'USDT': 6,
    'LUNA': 6,
    'TRX': 6,
    'USDC': 6,
    'SOL': 6,
};

export function getDecimalsForFormattedCryptoPrecision(cryptoCurrency: string): number {
    return listCryptoDecimals[cryptoCurrency] || 8;
}